import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsBar = ({ 
  selectedCount = 0, 
  onClearSelection,
  onBulkEnable,
  onBulkDisable,
  onBulkDelete,
  onBulkExport 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
              <Icon name="Check" size={14} color="white" />
            </div>
            <span className="text-sm font-medium text-primary">
              {selectedCount} product{selectedCount > 1 ? 's' : ''} selected
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearSelection}
            className="text-primary hover:text-primary"
          >
            Clear selection
          </Button>
        </div>

        <div className="flex items-center space-x-2">
          <Button
              variant="outline"
              size="sm"
              iconName="Play"
              iconPosition="left"
              onClick={onBulkEnable}   // ✅ this will run bulk mapping
              className="border-success/20 text-success hover:bg-success/5"
            >
              Bulk Mapping
            </Button> 
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Pause"
            iconPosition="left"
            onClick={onBulkDisable}
            className="border-warning/20 text-warning hover:bg-warning/5"
          >
            Disable
          </Button> */}
          
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onBulkExport}
          >
            Export
          </Button>
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Trash2"
            iconPosition="left"
            onClick={onBulkDelete}
            className="border-error/20 text-error hover:bg-error/5"
          >
            Delete
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;